import { noop } from 'lodash';
import { createContext, useContext } from 'react';

export type CollapsibleContextType = {
  open: boolean;
  toggle: () => void;
};
export const CollapsibleContext = createContext<CollapsibleContextType>({
  open: false,
  toggle: noop,
});

export const useCollapsible = () => useContext(CollapsibleContext);
